import { UserSelectors } from '@recruitee/account-data';
import { InterviewSchedule } from '@recruitee/http-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<InterviewSchedule>()(
  'InterviewSchedulesCollection',
  {
    references: makeRef => [makeRef('adminIds', 'admins', UserSelectors.byIds)],
    customActions: adapter => ({
      references: (state, payload: { data: InterviewSchedule[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

export {
  actions as InterviewSchedulesCollectionActions,
  selectors as InterviewSchedulesCollectionSelectors,
  reducer as InterviewSchedulesCollectionReducer,
  namespace as InterviewSchedulesCollectionNamespace,
};
